// extracted by mini-css-extract-plugin
export default {"actions":"bd1c8db5b4c00eba","downloadButton":"_200b32cf8e32d6bb","title":"f1d0bf04a2f8fa5a"};